import logins from "./logins.json"

export default logins;